import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSubscription } from '../components/SubscriptionProvider';

const SubscriptionSuccessPage = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { confirmCheckoutSession, refreshSubscription } = useSubscription();
	const [isLoading, setIsLoading] = useState(true);
	const [confirmMessage, setConfirmMessage] = useState(null);

	useEffect(() => {
		const syncAfterCheckout = async () => {
			try {
				const sessionId = searchParams.get('session_id');
				if (sessionId) {
					const result = await confirmCheckoutSession(sessionId);
					if (result?.message) setConfirmMessage(result.message);
					else if (result?.allowancesReset) {
						setConfirmMessage(
							'Your subscription was renewed. Document and source allowances have been reset for the new billing period.'
						);
					}
				} else {
					await refreshSubscription();
				}
			} catch (error) {
				console.error('Error syncing subscription after checkout:', error);
			} finally {
				setIsLoading(false);
			}
		};

		syncAfterCheckout();
	}, [confirmCheckoutSession, refreshSubscription, searchParams]);

	const handleGoToDashboard = () => {
		navigate('/dashboard');
	};

	const handleGoToSubscription = () => {
		navigate('/subscription');
	};

	return (
		<div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
			<div className="w-full max-w-md rounded-lg bg-white p-8 shadow-lg">
				{isLoading ? (
					<div className="text-center">
						<div className="mb-4 inline-block h-12 w-12 animate-spin rounded-full border-4 border-blue-600 border-t-transparent"></div>
						<p className="text-gray-600">Processing your subscription...</p>
					</div>
				) : (
					<>
						<div className="mb-4 flex justify-center">
							<div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
								<svg
									className="h-8 w-8 text-green-600"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M5 13l4 4L19 7"
									/>
								</svg>
							</div>
						</div>

						<div className="mb-6 text-center">
							<h1 className="mb-2 text-2xl font-bold text-gray-900">Subscription Successful!</h1>
							<p className="text-gray-600">
								{confirmMessage ||
									'Your subscription has been activated. You now have access to all features in your plan.'}
							</p>
						</div>

						<div className="space-y-3">
							<button
								onClick={handleGoToDashboard}
								className="w-full rounded-lg bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700"
							>
								Go to Dashboard
							</button>
							<button
								onClick={handleGoToSubscription}
								className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 font-semibold text-gray-700 hover:bg-gray-50"
							>
								View Subscription
							</button>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default SubscriptionSuccessPage;
